import { AppEnv, Env } from './types';
import { enumValues, throwIfFalsy } from './typescript';

const appEnv = process.env.REACT_APP_ENV;

throwIfFalsy(appEnv, `'REACT_APP_ENV' variable must be set`);
throwIfFalsy(process.env.REACT_APP_VERSION, `'REACT_APP_VERSION' variable must be set`);
throwIfFalsy(process.env.REACT_APP_API_URL, `'REACT_APP_API_URL' variable must be set`);
throwIfFalsy(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    `'REACT_APP_STRIPE_PUBLIC_KEY' variable must be set`,
);
throwIfFalsy(enumValues(AppEnv).includes(appEnv), `APP_ENV=${appEnv} is not allowed`);
throwIfFalsy(
    process.env.REACT_APP_ENV_SENTRY_DSN,
    `'REACT_APP_ENV_SENTRY_DSN' variable must be set`,
);

export const ENV: Env = {
    APP_ENV: appEnv as AppEnv,
    APP_VERSION: process.env.REACT_APP_VERSION,
    APP_IN_MEMORY: process.env.REACT_APP_IN_MEMORY === 'true',
    API_URL: process.env.REACT_APP_API_URL,
    STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    SENTRY_DSN: process.env.REACT_APP_ENV_SENTRY_DSN,
    ELASTIC_APM_ACTIVE: process.env.REACT_APP_ELASTIC_APM_ACTIVE === 'true',
    ELASTIC_APM_ENVIRONMENT: process.env.REACT_APP_ELASTIC_APM_ENVIRONMENT,
    ELASTIC_APM_SERVICE_NAME: process.env.REACT_APP_ELASTIC_APM_SERVICE_NAME,
    ELASTIC_APM_SERVER_URL: process.env.REACT_APP_ELASTIC_APM_SERVER_URL,
};
